import React from 'react';

import "./styles.css";

export default function Abas(props) {
  const { tabs, value, handleChange } = props;
  return (
    <div className="container-abas-precos-exames-botoes">
      {tabs.map((t, i) => (
        <button
          key={t}
          type="button"
          className={(Number(value) === (Number(i))) ? "aba-precos-exames-on" : "aba-precos-exames"}
          onClick={() => handleChange(i)}
        >
          {t}
        </button>
      ))}
    </div>
  )
}
